var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5671_61115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7012 72.1509L47.4151 79.8648L26.2019 101.078L18.488 93.3641L39.7012 72.1509Z",
    fill: "#1F3238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 54.5,
    r: 30.5,
    fill: "#09FDD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4545 84.5454C82.0231 84.5454 95.4545 71.1139 95.4545 54.5454C95.4545 37.9768 82.0231 24.5454 65.4545 24.5454C48.886 24.5454 35.4545 37.9768 35.4545 54.5454C35.4545 71.1139 48.886 84.5454 65.4545 84.5454ZM65.4545 89.9999C85.0355 89.9999 100.909 74.1264 100.909 54.5454C100.909 34.9644 85.0355 19.0908 65.4545 19.0908C45.8735 19.0908 30 34.9644 30 54.5454C30 74.1264 45.8735 89.9999 65.4545 89.9999Z",
    fill: "#1F3238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8185 41.5908L73.6367 49.7726L81.8185 57.9545",
    stroke: "#1F3238",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0916 41.5908L57.2734 49.7726L49.0916 57.9545",
    stroke: "#1F3238",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 69.5456C52.5 69.5456 57.5909 66.8184 65.7955 66.8184C74 66.8184 79.0909 69.5456 79.0909 69.5456",
    stroke: "#1F3238",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5671_61115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.7001f19f8a78bc70fad6183d88991842.svg";
export { ForwardRef as ReactComponent };